import * as React from 'react';
export const platformSvg = React.forwardRef(function platformSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm2.216 4.5 3.667 2h.235l3.666-2-3.666-2h-.235l-3.667 2Zm4.62-3.317A1.5 1.5 0 0 0 6.118 1h-.235a1.5 1.5 0 0 0-.719.183L.44 3.761a.842.842 0 0 0 0 1.478l4.725 2.578c.22.12.468.183.719.183h.235a1.5 1.5 0 0 0 .718-.183l4.725-2.578a.842.842 0 0 0 0-1.478L6.836 1.183Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M.104 7.82a.75.75 0 0 1 1.027-.266l4.32 2.546a1.083 1.083 0 0 0 1.099 0l4.32-2.546a.75.75 0 1 1 .761 1.292l-4.32 2.546a2.582 2.582 0 0 1-2.622 0L.369 8.846A.75.75 0 0 1 .104 7.82Z',
    }),
  );
});
platformSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var platform = {
  category: 'icon',
  colorable: true,
  name: 'platform',
  svg: platformSvg,
};
